import React, { useRef, useState } from 'react';

/**
 * Кнопка «Собран» для АРМов флориста/упаковщика. Если нужно фото (фото-контроль
 * или заказ Flowwow) — открывает камеру, после снимка вызывает onPhoto(file), иначе
 * сразу onReady(). Одно действие для сотрудника: снял → заказ собран (у Flowwow
 * фото в этот же момент уходит покупателю).
 */
export default function ReadyWithPhotoButton({ needPhoto, onPhoto, onReady, label = 'Собран', busy = false, style }) {
  const inputRef = useRef(null);
  const [working, setWorking] = useState(false);
  const disabled = busy || working;

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setWorking(true);
    try { await onPhoto(file); } finally { setWorking(false); }
  };

  const handleClick = async () => {
    if (needPhoto) { inputRef.current?.click(); return; }
    setWorking(true);
    try { await onReady(); } finally { setWorking(false); }
  };

  return (
    <>
      <button type="button" onClick={handleClick} disabled={disabled} style={{ ...style, opacity: disabled ? 0.6 : 1 }}
        title={needPhoto ? 'Снять фото собранного заказа — без него в «Собран» не перевести' : undefined}>
        {working ? 'Отправка...' : (needPhoto ? `📷 ${label}` : label)}
      </button>
      {needPhoto && (
        <input ref={inputRef} type="file" accept="image/jpeg,image/png" capture="environment" onChange={handleFile} style={{ display: 'none' }} />
      )}
    </>
  );
}
